export const slideDeckColorThemes = {
  tema: {
    id: "tema",
    label: "iTEMA Orange",
    description: "Warm classroom orange — matches iTEMA",
    swatch: ["#b87300", "#f19500"],
    preview: {
      titleGradientFrom: "#a86f00",
      titleGradientTo: "#f5ae33",
      titleText: "#ffffff",
      titleMuted: "#fde4c4",
      titleBullets: "#fff0d9",
      sectionBg: "#fff9ee",
      sectionTitle: "#875300",
      contentBg: "#ffffff",
      contentText: "#0f172a",
      contentMuted: "#64748b",
      contentBullets: "#334155",
      bulletDot: "#f19500",
      accent: "#f19500",
      accentSoft: "#fff9ee",
      stripActiveBorder: "#f19500",
      stripActiveBg: "#fff9ee",
      stripActiveText: "#875300",
    },
    ppt: {
      primary: "F19500",
      text: "0F172A",
      muted: "64748B",
      light: "FFF9EE",
      white: "FFFFFF",
      titleBar: "875300",
    },
  },
  ocean: {
    id: "ocean",
    label: "Ocean Blue",
    description: "Calm, professional blue tones",
    swatch: ["#1e40af", "#3b82f6"],
    preview: {
      titleGradientFrom: "#1e3a8a",
      titleGradientTo: "#3b82f6",
      titleText: "#ffffff",
      titleMuted: "#bfdbfe",
      titleBullets: "#dbeafe",
      sectionBg: "#eff6ff",
      sectionTitle: "#2563eb",
      contentBg: "#ffffff",
      contentText: "#0f172a",
      contentMuted: "#64748b",
      contentBullets: "#334155",
      bulletDot: "#3b82f6",
      accent: "#2563eb",
      accentSoft: "#eff6ff",
      stripActiveBorder: "#3b82f6",
      stripActiveBg: "#eff6ff",
      stripActiveText: "#1d4ed8",
    },
    ppt: {
      primary: "2563EB",
      text: "0F172A",
      muted: "64748B",
      light: "EFF6FF",
      white: "FFFFFF",
      titleBar: "1D4ED8",
    },
  },
  forest: {
    id: "forest",
    label: "Forest Green",
    description: "Natural, focused green palette",
    swatch: ["#166534", "#22c55e"],
    preview: {
      titleGradientFrom: "#14532d",
      titleGradientTo: "#22c55e",
      titleText: "#ffffff",
      titleMuted: "#bbf7d0",
      titleBullets: "#dcfce7",
      sectionBg: "#f0fdf4",
      sectionTitle: "#16a34a",
      contentBg: "#ffffff",
      contentText: "#0f172a",
      contentMuted: "#64748b",
      contentBullets: "#334155",
      bulletDot: "#22c55e",
      accent: "#16a34a",
      accentSoft: "#f0fdf4",
      stripActiveBorder: "#22c55e",
      stripActiveBg: "#f0fdf4",
      stripActiveText: "#15803d",
    },
    ppt: {
      primary: "16A34A",
      text: "0F172A",
      muted: "64748B",
      light: "F0FDF4",
      white: "FFFFFF",
      titleBar: "15803D",
    },
  },
  royal: {
    id: "royal",
    label: "Royal Purple",
    description: "Bold, creative purple accents",
    swatch: ["#6b21a8", "#a855f7"],
    preview: {
      titleGradientFrom: "#581c87",
      titleGradientTo: "#a855f7",
      titleText: "#ffffff",
      titleMuted: "#e9d5ff",
      titleBullets: "#f3e8ff",
      sectionBg: "#faf5ff",
      sectionTitle: "#9333ea",
      contentBg: "#ffffff",
      contentText: "#0f172a",
      contentMuted: "#64748b",
      contentBullets: "#334155",
      bulletDot: "#a855f7",
      accent: "#9333ea",
      accentSoft: "#faf5ff",
      stripActiveBorder: "#a855f7",
      stripActiveBg: "#faf5ff",
      stripActiveText: "#7e22ce",
    },
    ppt: {
      primary: "9333EA",
      text: "0F172A",
      muted: "64748B",
      light: "FAF5FF",
      white: "FFFFFF",
      titleBar: "7E22CE",
    },
  },
  slate: {
    id: "slate",
    label: "Slate Professional",
    description: "Neutral, corporate-ready styling",
    swatch: ["#334155", "#64748b"],
    preview: {
      titleGradientFrom: "#1e293b",
      titleGradientTo: "#475569",
      titleText: "#ffffff",
      titleMuted: "#cbd5e1",
      titleBullets: "#e2e8f0",
      sectionBg: "#f8fafc",
      sectionTitle: "#334155",
      contentBg: "#ffffff",
      contentText: "#0f172a",
      contentMuted: "#64748b",
      contentBullets: "#334155",
      bulletDot: "#475569",
      accent: "#334155",
      accentSoft: "#f1f5f9",
      stripActiveBorder: "#475569",
      stripActiveBg: "#f1f5f9",
      stripActiveText: "#1e293b",
    },
    ppt: {
      primary: "334155",
      text: "0F172A",
      muted: "64748B",
      light: "F1F5F9",
      white: "FFFFFF",
      titleBar: "1E293B",
    },
  },
};

export const colorThemeOptions = Object.values(slideDeckColorThemes).map(
  ({ id, label }) => ({ id, label }),
);

export const defaultColorThemeId = "tema";

export function resolveSlideDeckColorTheme(themeId) {
  return slideDeckColorThemes[themeId] ?? slideDeckColorThemes[defaultColorThemeId];
}
